import "./IconBack.scss";

type Props = {
  width: string;
  height: string;
  color?: string;
};

export const IconBack = (props: Props) => {
  const { width, height, color = "#2C2C2C" } = props;
  return (
    <span className="icon-back" style={{ width, height }}>
      <svg viewBox="0 0 11 16" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.577148 7.38965L6.76465 1.23438C7.05469 0.912109 7.53809 0.912109 7.86035 1.23438C8.15039 1.52441 8.15039 2.00781 7.86035 2.29785L2.18848 7.9375L7.82812 13.6094C8.15039 13.8994 8.15039 14.3828 7.82812 14.6729C7.53809 14.9951 7.05469 14.9951 6.76465 14.6729L0.577148 8.48535C0.254883 8.19531 0.254883 7.71191 0.577148 7.38965Z"
          fill={color}
        />
      </svg>
    </span>
  );
};
